"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _I18n = _interopRequireDefault(require("I18n"));

var _hubspotTimezoneUtilsUtils = _interopRequireDefault(require("hubspot.timezone-utils.utils.getTranslatedTimezoneGroups"));

var _hubspotTimezoneUtilsUtils2 = _interopRequireDefault(require("hubspot.timezone-utils.utils.groupsToSelectOpts"));

var previousLocale;
var options;
var optionsMap;

function _default() {
  var shouldRefetch = _I18n.default.locale !== previousLocale;
  previousLocale = _I18n.default.locale;

  if (!options || shouldRefetch) {
    options = (0, _hubspotTimezoneUtilsUtils2.default)((0, _hubspotTimezoneUtilsUtils.default)());
    optionsMap = options.reduce(function (accI, optionGroup) {
      return optionGroup.options.reduce(function (accJ, option) {
        accJ[option.value] = option.text;
        return accJ;
      }, accI);
    }, {});
  }

  return {
    options: options,
    optionsMap: optionsMap
  };
}

module.exports = exports.default;